export enum Environments {
  US_PRODUCTION = `US_PRODUCTION`,
  US_STAGE = `US_STAGE`,
  UK_PRODUCTION = `UK_PRODUCTION`,
  UK_STAGE = `UK_STAGE`,
  DEV = `DEV`,
}
